export default __webpack_public_path__ + "static/media/N_wdt_c_cap_2.114f47ee.mp3";